define('adminSnippetsListHeaderToolsView',[
  'module',
  'app',
  'underscore',
  'jquery',
  'windows',
  'tableHeaderFieldView',
  'adminSnippetsEditPopupView',
  'template!adminSnippetsListHeaderToolsView'
], function (
  Module,
  App,
  _,
  $,
  Windows,
  FieldView,
  EditPopupView,
  Tpl
) {
  'use strict';

  Module.exports = FieldView.extend({
    template: Tpl,
    className: 'admin-snippets-list-header-tools-view table-field-view',

    events: {
      'click .btn-create': 'onCreate'
    },

    serializeData: function () {
      return {
        createLabel: _.i18n('admin.snippets.create', null, 'Create snippet')
      };
    },

    onCreate: function () {
      var tableView = this.options && this.options.tableView;
      Windows.open({
        view: function () {
          return new EditPopupView({
            snippetSecId: null,
            onConfirm: function () { if (tableView) tableView.refresh(); }
          });
        },
        title: _.i18n('admin.snippets.createTitle', null, 'New snippet'),
        width: 640,
        height: 620,
        modal: true
      });
    }
  });
});

